import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';
import SocialMediaLinkDataController from 'redpoints-restapi-connector/controller/SocialMediaLinkDataController';

import {
  CONNECTOR_REQUEST,
  SOCIAL_MEDIA_MESSAGES_CLEAR,
  SOCIAL_MEDIA_MESSAGES_FETCH_MESSAGES,
} from './actionTypes';

export const socialMediaMessagesClear = () => ({
  type: SOCIAL_MEDIA_MESSAGES_CLEAR,
});

export const socialMediaMessagesFetchMessages = linkId => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: SOCIAL_MEDIA_MESSAGES_FETCH_MESSAGES,
    connectorMethod: SocialMediaLinkDataController.get,
    sortedParameters: [linkId, false],
    expectedStatus: HttpStatus.OK,
  },
});
